import React, {useRef} from "react";
import styles from "./StaticStatistic.module.css"
import cx from "classnames"
import Image from "next/image";
import {useInView} from "framer-motion";

const StaticStatistic = ({title, img1, img2, img3, title1, title2, title3, info1, info2, info3}) => {
    const refVal1 = useRef()
    const isVal1InView = useInView(refVal1)
    const refVal2 = useRef()
    const isVal2InView = useInView(refVal2)
    const refVal3 = useRef()
    const isVal3InView = useInView(refVal3)

    return(
        <div className={cx(styles.statisticContainer, "mt-5", "py-5", "px-4")}>
            <h2 className={cx(styles.statisticTitle)}>{title}</h2>
            <div className={cx(styles.statisticWrapper,"container","h-100", "d-grid", "my-5", "my-md-0")}>
                <div
                    className={cx(styles.statisticItem, "d-flex", "flex-column", "align-items-center", "justify-content-start")}>
                    <Image
                        style={{
                            transform: isVal1InView ? "none" : "translateY(-50px)",
                            opacity: isVal1InView ? 1 : 0,
                            transition: "all ease 1400ms",
                            transitionDelay: "0.1s"
                        }}
                        src={img1} width={100} height={100} alt={title1} />
                    <strong
                        style={{
                            transform: isVal1InView ? "none" : "translateX(-50px)",
                            opacity: isVal1InView ? 1 : 0,
                            transition: "all ease 1400ms",
                            transitionDelay: "0.1s"
                        }}
                        className="text-center my-2">{title1}</strong>
                    <span
                        style={{
                            transform: isVal1InView ? "none" : "translateY(50px)",
                            opacity: isVal1InView ? 1 : 0,
                            transition: "all ease 1400ms",
                            transitionDelay: "0.1s"
                        }}
                    >{info1}</span>
                    <div ref={refVal1}></div>
                </div>
                <div
                    className={cx(styles.statisticItem, "d-flex", "flex-column", "align-items-center", "justify-content-start")}>
                    <Image
                        style={{
                            transform: isVal1InView ? "none" : "translateY(-50px)",
                            opacity: isVal1InView ? 1 : 0,
                            transition: "all ease 1400ms",
                            transitionDelay: "0.3s"
                        }}
                        src={img2} width={100} height={100} alt={title2} />
                    <strong
                        style={{
                            transform: isVal1InView ? "none" : "translateX(-50px)",
                            opacity: isVal1InView ? 1 : 0,
                            transition: "all ease 1400ms",
                            transitionDelay: "0.3s"
                        }}
                        className="text-center my-2">{title2}</strong>
                    <span
                        style={{
                            transform: isVal2InView ? "none" : "translateY(50px)",
                            opacity: isVal2InView ? 1 : 0,
                            transition: "all ease 1400ms",
                            transitionDelay: "0.3s"
                        }}
                    >{info2}</span>
                    <div ref={refVal2}></div>
                </div>
                <div
                    className={cx(styles.statisticItem, "d-flex", "flex-column", "align-items-center", "justify-content-start")}>
                    <Image
                        style={{
                            transform: isVal3InView ? "none" : "translateY(-50px)",
                            opacity: isVal3InView ? 1 : 0,
                            transition: "all ease 1400ms",
                            transitionDelay: "0.5s"
                        }}
                        src={img3} width={100} height={100} alt={title3} />
                    <strong
                        style={{
                            transform: isVal3InView ? "none" : "translateX(-50px)",
                            opacity: isVal3InView ? 1 : 0,
                            transition: "all ease 1400ms",
                            transitionDelay: "0.5s"
                        }}
                        className="text-center my-2">{title3}</strong>
                    <span
                        style={{
                            transform: isVal3InView ? "none" : "translateY(50px)",
                            opacity: isVal3InView ? 1 : 0,
                            transition: "all ease 1400ms",
                            transitionDelay: "0.5s"
                        }}
                    >{info3}</span>
                    <div ref={refVal3}></div>
                </div>

            </div>
        </div>
    )
}
export default StaticStatistic